export default "__VITE_ASSET__BTn9nBB8__"